import React from 'react';

import { VerticalStackLayoutFeatureArea } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { InsertionLayoutFeatureArea } from '../../../../../store/slices/applicationSlice';
import { BeamPocketFeatureAreaControls } from './BeamPocketFeatureAreaControls';
import { ChaseFeatureAreaControls } from './ChaseFeatureAreaControls';
import { StepFeatureAreaControls } from './StepFeatureAreaControls';
import { VerticalStackFeatureAreaControls } from './VerticalStackFeatureAreaControls';

interface Props {
  value: InsertionLayoutFeatureArea;
  disabled?: boolean;
  onChange: (value: InsertionLayoutFeatureArea) => void;
}

export function FeatureAreaUniquePropertyControls({ value, disabled, onChange }: Props) {
  switch (value.featureType) {
    case 'Chase':
      return <ChaseFeatureAreaControls value={value} disabled={disabled} onChange={onChange} />;

    case 'Step':
      return <StepFeatureAreaControls value={value} disabled={disabled} onChange={onChange} />;

    case 'BeamPocket':
      return <BeamPocketFeatureAreaControls value={value} disabled={disabled} onChange={onChange} />;

    case 'VerticalStack':
      return (
        <VerticalStackFeatureAreaControls
          value={value as Omit<VerticalStackLayoutFeatureArea, 'guid'>}
          disabled={disabled}
          onChange={onChange}
        />
      );

    default:
      assertExhaustiveSwitch(value);
  }
}
